<template>
  <sBadge
    v-if="showBtn"
    color="var(--white-color)"
    :content="actualElement.length || ''"
    data-qa="choise-winner-btn-badge"
    offset-x="24"
    offset-y="15"
    overlap
    text-color="var(--black-color)">
    <sButton
      class="mr-3 px-4"
      color="var(--white-color)"
      :data-qa="`change-to-${winners ? 'not-' : ''}winner`"
      :loading="loading"
      small
      type="border"
      @click="chooseWinner">
      {{ text }}
    </sButton>
  </sBadge>
</template>

<script>
import { eventBus } from '@/main'
import SmarttenderApi from '@/api/smarttenderApi'
const st_api = new SmarttenderApi()

export default {
  name: 'chooseWinnerBtn',
  data() {
    return {
      loading: false
    }
  },
  props: {
    options: Object,
    /**
    ** https://app.clickup.com/t/2169750/869dxakxj
    ** режим работы кнопки
    ** default - смешанный. В зависимости от данных
    ** select - выбор победителя
    ** remove - отмена выбора победителя
    **/
    mode: {
      type: String,
      default: 'default',
      validator: function (value) {
        const correct = ['default', 'select', 'remove'].indexOf(value) !== -1
        return correct
      },
    }
  },
  computed: {
    text() {
      if (this.mode === 'remove') { return this.$t('Tenders.RemoveTenderWinner') }
      if (this.mode === 'select') { return this.$t('Tenders.ChooseWinner') }
      return this.winners ? this.$t('Tenders.RemoveTenderWinner') : this.$t('Tenders.ChooseWinner')
    },
    winners() {
      return this.options?.elements?.every(el => el.selectedBid)
    },
    has_some_winners() {
      return this.options?.elements?.some(el => el.selectedBid) && this.options?.elements?.some(el => !el.selectedBid)
    },
    actualElement() {
      if (this.mode === 'select') {
        return this.options?.elements?.filter(el => !el.selectedBid)
      } else if (this.mode === 'remove') {
        return this.options?.elements?.filter(el => el.selectedBid)
      }
      return this.options?.elements
    },
    showBtn() {
      const can_choose_winners = this.$acl.check('onlyTenders')
      const status = this.options?.tender?.tenderStatus?.id
      const analys = status == this.statuseKeys.BID_ANALYSIS
      const after_finish = (status == this.statuseKeys.COMPLETED || status == this.statuseKeys.PURCHASE_NOT_PLACED) && this.options?.name == 'change-winner'
      const statusOk = can_choose_winners && this.options?.tender && (analys || after_finish)

      let result
      if (this.mode === 'select' || this.mode === 'remove') {
        result = statusOk && this.actualElement.length
      } else {
        result = statusOk && !this.has_some_winners
      }

      this.$emit('showActions', { toolbar: result })
      return result
    }
  },
  methods: {

    chooseWinner() {
      let that = this
      if ( this.options?.name == 'change-winner' ) {
        that.options.elements.forEach(el => el.selectedBid = !el.selectedBid )
        eventBus.$emit('offerTab_changeWinnerState', that.options.elements )
        eventBus.$emit('changedWinnersFinishedTender', that.options.elements )
        that.options.callback()
        return
      }
      const isRemove = this.mode === 'remove' || (this.mode === 'default' && this.winners)
      const isSelect = this.mode === 'select' || (this.mode === 'default' && !this.winners)
      let model = {
        tenderId: this.options?.tender?.tenderId,
        removeWinnerBidItemIds: isRemove ? this.actualElement.map(el => el.id) : [],
        selectWinnerBidItemIds: isSelect ? this.actualElement.map(el => ({
          bidItemId: el.id,
          quantity: el.quantity
        })) : [],
      }
      this.loading = true
      st_api.changeTenderWinner(model)
        .then(res => {
          if (res?.success) {
            that.options.elements.forEach(el => el.selectedBid = !el.selectedBid)
            that.options.callback()
            eventBus.$emit('offerTab_changeWinnerState', that.options.elements )
          }
        })
        .finally(() => {
          this.loading = false
        })
    },
  }
}
</script>
